import useLang from "../../hooks/useLang";
import useConfigurationsList from "./hooks/useConfigurationsList";
import { PageHeader } from "../../components/Header";
import DynamicTable from "../../components/DynamicTable";
import Button from "../../components/Button";
import {
  ConfirmationModalControlled,
  FormModalControlled,
} from "../../components/Modal";
import Input from "../../components/Input";

const ConfigurationsList = () => {
  const lang = useLang();
  const {
    tableAttribs,
    disableChange,
    confirmationOpen,
    handleClose,
    handleSubmit,
    handleCreateSubmit,
    handleCancel,
    idToDelete,
    handleCreate,
    creationOpen,
    newId,
    setNewId,
    newName,
    setNewName,
  } = useConfigurationsList();

  return (
    <>
      <PageHeader>
        <h1>{lang("configurator")}</h1>
      </PageHeader>
      <div
        style={{
          display: "flex",
          flexGrow: "1",
          justifyContent: "flex-end",
          marginBottom: "30px",
        }}
      >
        <Button important disabled={disableChange} onClick={handleCreate}>
          Sukurti
        </Button>
      </div>
      <DynamicTable noVerticalLines {...tableAttribs} />
      <ConfirmationModalControlled
        isOpen={confirmationOpen}
        onClose={handleClose}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        submitLabel={"Ištrinti"}
        cancelLabel={"Atšaukti"}
      >
        <h2>{`Ar tikrai norite ištrinti ${idToDelete}?`}</h2>
      </ConfirmationModalControlled>
      <FormModalControlled
        isOpen={creationOpen}
        onClose={handleClose}
        onSubmit={handleCreateSubmit}
        onCancel={handleCancel}
        submitLabel={"Sukurti"}
        cancelLabel={"Atšaukti"}
      >
        <h2>Sukurti naują modelį</h2>
        <div
          style={{
            display: "flex",
            gap: "var(--gap)",
            flexDirection: "column",
            margin: "var(--gap) 0",
          }}
        >
          <Input
            label="ID"
            value={newId}
            onChange={(e) => {
              setNewId(e.currentTarget.value);
            }}
          />
          <Input
            label="Pavadinimas"
            value={newName}
            onChange={(e) => {
              setNewName(e.currentTarget.value);
            }}
          />
        </div>
      </FormModalControlled>
    </>
  );
};

export default ConfigurationsList;
